import React, { useState } from "react";

const AdminResetPassword = () => {
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://www.example.com/api/admin_reset_password.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, newPassword }),
      });

      const data = await response.json();
      setMessage(data.message || "Passwort wurde zurückgesetzt.");
    } catch (error) {
      setMessage("Fehler beim Zurücksetzen des Passworts.");
    }
  };

  return (
    <div className="container mx-auto px-4 sm:px-6 py-12">
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-lg max-w-md mx-auto">
        <h2 className="text-2xl font-bold mb-4">Passwort für Benutzer zurücksetzen</h2>
        <div className="mb-4">
          <label className="block text-sm font-medium">E-Mail des Benutzers</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 block w-full px-4 py-2 border rounded-md"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium">Neues Passwort</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="mt-1 block w-full px-4 py-2 border rounded-md"
            required
          />
        </div>
        <button
          type="submit"
          className="w-full bg-pink-500 text-slate-50 py-2 px-4 rounded-md hover:bg-black transition"
        >
          Passwort zurücksetzen
        </button>
      </form>
      {message && <p className="mt-4 text-center text-gray-600">{message}</p>}
    </div>
  );
};

export default AdminResetPassword;